import cx from "classnames"
import SearchIcon from "../../icons/SearchIcon"
import SvgIcon from "../../shared/components/SvgIcon"
import { useContext, useState } from "react"
import { SimilaritySearchContext } from "./SimilaritySearchContainer"
import { SPOTIFY_TRACK_LINK_REGEX, YOUTUBE_LINK_REGEX } from "../../shared/utils/helpers"

const SimilaritySearchInput = () => {
  const { setSearchQueryTerm, searchMode, setSearchMode } = useContext(SimilaritySearchContext)
  const [searchQueryForm, setSearchQueryForm] = useState("")
  const [isMenuVisible, setIsMenuVisible] = useState(false)

  const searchModeOptions = [
    { label: "General Vibe", value: "mostRepresentative" },
    { label: "Whole Song", value: "complete" },
  ]

  const handleSearchChange = (e) => {
    setSearchQueryForm(e.target.value)
  }

  const handleMenuToggle = () => {
    setIsMenuVisible(!isMenuVisible)
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    if (YOUTUBE_LINK_REGEX.test(searchQueryForm)) {
      setSearchQueryTerm(YOUTUBE_LINK_REGEX.exec(searchQueryForm)[0])
    } else if (SPOTIFY_TRACK_LINK_REGEX.test(searchQueryForm)) {
      setSearchQueryTerm(searchQueryForm)
    } else {
      setSearchQueryTerm("")
    }
  }

  const handleSearchModeClick = (option) => {
    setSearchMode(option)
    setIsMenuVisible(false)
  }

  return (
    <form id="search" className="search mm-filter" onSubmit={handleSearchSubmit}>
      <div id="mm-search-input" className={cx("")}>
        <div className="search-input-group">
          <div className="icon">
            <SearchIcon />
          </div>
          <label>Search</label>
          <input
            autoFocus
            type="text"
            value={searchQueryForm}
            onChange={handleSearchChange}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck="false"
            placeholder="Paste a YouTube or Spotify link to see similar songs"
            aria-label="Enter search text"
          />
        </div>

        <div className="search-filter" onClick={handleMenuToggle}>
          <span className="expand icon"></span>
          <div className="target">
            {searchMode?.label ?? "General Vibe"} <span></span>
          </div>
          <div className={cx("menu", isMenuVisible ? "visible" : "")}>
            {searchModeOptions.map((option) => {
              const isSelected =
                searchMode?.value === option.value ||
                (!searchMode && option.value === "mostRepresentative")
              return (
                <div
                  key={option.value}
                  className={cx("item", isSelected ? "selected" : "")}
                  data-value={option.value}
                  data-cy={option.value}
                  onClick={() => handleSearchModeClick(option)}
                >
                  {isSelected && (
                    <SvgIcon svgClass="CheckIcon" fillRule="evenodd">
                      <polygon
                        className="icon-border"
                        points="11.941,28.877 0,16.935 5.695,11.24 11.941,17.486 26.305,3.123 32,8.818"
                      />
                    </SvgIcon>
                  )}
                  <span>{option.label}</span>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      <button className="youtube-submit" type="submit">
        Search
      </button>
    </form>
  )
}

export default SimilaritySearchInput